import React, { useState, useEffect, useCallback } from 'react';
import ContentWrapper from '../../Layout/ContentWrapper';
import * as adminService from '../Services/adminService';
import Companies from './companies';
import Users from './users';
import TenantList from './tenants';
import Roles from './roles';
import Statistics from './statistics';
import OverviewHeader from './overviewHeader';
import { SpinnerLoader } from '../Components/shared/spinnerLoader';

const Overview = () => {
  const [adminData, setAdminData] = useState({
    companies: [{}],
    tenants: [{}],
    users: [{}],
    roles: [],
  });
  const [adminInfo, setAdminInfo] = useState({
    allTimeInfoForAdminDto: {},
    lastWeekInfoForAdminDto: {},
    yesterdayInfoForAdminDto: {},
  });
  const [loading, setLoading] = useState(true);
  const [infoLoading, setInfoLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await adminService.getDataForAdminUser();
      setAdminData(data);
    } catch (error) {
      console.error('Failed to fetch admin data:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const onBtnGetAdminInfoClick = useCallback(async () => {
    setInfoLoading(true);
    try {
      const { data } = await adminService.getInfoForAdminUser();
      setAdminInfo(data);
    } catch (error) {
      console.error('Failed to fetch admin info:', error);
    } finally {
      setInfoLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const { companies, tenants, users, roles } = adminData;

  return (
    <ContentWrapper>
      {loading ? (
        <SpinnerLoader />
      ) : (
        <>
          <OverviewHeader users={users} companies={companies} tenants={tenants} roles={roles} adminData={adminData} />
          <Statistics adminInfo={adminInfo} onBtnGetAdminInfoClick={onBtnGetAdminInfoClick} loading={infoLoading} />
          <Companies companies={companies} refresh={refresh} />
          <TenantList tenants={tenants} />
          <Users users={users} />
          <Roles roles={roles} />
        </>
      )}
    </ContentWrapper>
  );
};

export default Overview;
